import React, { useMemo } from 'react';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import {
  dataGridTextSorter,
  dataGridDateSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const NewsTable = ({ news, onDelete, onEditClick, onPreviewClick }) => {
  const { t } = useTranslation();
  const titleSkTextFilterProps = useDataGridTextFilter('title_sk');
  const titleEnTextFilterProps = useDataGridTextFilter('title_en');
  const addedDateRangeFilterProps = useDataGridDateRangeFilter('updated_at');
  const validFromDateRangeFilterProps =
    useDataGridDateRangeFilter('valid_from');
  const topToDateRangeFilterProps = useDataGridDateRangeFilter('top_to');

  const columns = useMemo(
    () => [
      {
        title: t('Názov (slovensky)'),
        dataIndex: 'title_sk',
        ellipsis: true,
        sorter: dataGridTextSorter('title_sk'),
        ...titleSkTextFilterProps,
      },
      {
        title: t('Názov (anglicky)'),
        dataIndex: 'title_en',
        ellipsis: true,
        sorter: dataGridTextSorter('title_en'),
        ...titleEnTextFilterProps,
      },
      {
        title: t('Posledná zmena'),
        dataIndex: 'updated_at',
        sorter: dataGridDateSorter('updated_at'),
        defaultSortOrder: 'updated_at',
        render: (date) =>
          (date &&
            new Date(date).toLocaleString().replace(/(.*)\D\d+/, '$1')) ||
          '-',
        ...addedDateRangeFilterProps,
        width: 170,
      },
      {
        title: t('Navrchu do'),
        dataIndex: 'top_to',
        sorter: dataGridDateSorter('top_to'),
        render: (date) =>
          (date &&
            new Date(date).toLocaleString().replace(/(.*)\D\d+/, '$1')) ||
          '-',
        ...topToDateRangeFilterProps,
        width: 170,
      },
    ],
    [
      addedDateRangeFilterProps,
      titleSkTextFilterProps,
      titleEnTextFilterProps,
      validFromDateRangeFilterProps,
      topToDateRangeFilterProps,
      t,
    ],
  );

  return (
    <>
      <DataGrid
        rowKey={(news) => news.id}
        columns={columns}
        dataSource={news || []}
        permissionsBasic={'news'}
        uniqueTableId={'news-table'}
        onRowClick={onEditClick}
        onEditClick={onEditClick}
        onDelete={onDelete}
        onPreviewClick={onPreviewClick}
      />
    </>
  );
};

NewsTable.propTypes = {
  news: PropTypes.array,
  onDelete: PropTypes.func,
  onEditClick: PropTypes.func,
  onCreateClick: PropTypes.func,
  onPreviewClick: PropTypes.func,
};

export default NewsTable;
